import { patchRequest, getRequest } from 'apis/ApiInstence';
import { put } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { successOrderListDB, failedOrderListDB, updateOrderStatusInList } from 'slice/orderSliceDB';

export function* updateOrderAPI({ payload }) {
    try {
      const statusValue =
        payload?.data?.status ||
        payload?.data?.order_status ||
        payload?.data?.orderStatus;

      const attemptPayloads = [payload?.data].filter(Boolean);
      if (statusValue) {
        attemptPayloads.push({ status: statusValue });
        attemptPayloads.push({ order_status: statusValue });
        attemptPayloads.push({ orderStatus: statusValue });
      }

      let updateResponse;
      let lastError;
      for (const data of attemptPayloads) {
        try {
          updateResponse = yield patchRequest(`order/${payload.id}`, data);
          if (updateResponse?.status === 200) {
            break;
          }
        } catch (error) {
          lastError = error;
        }
      }

      if (updateResponse?.status === 200) {
        yield put(updateOrderStatusInList({
          id: payload.id,
          status: statusValue,
          tracking_url: payload?.data?.tracking_url || '',
        }));
        toast.success(updateResponse?.data?.message || 'Order updated');
      } else {
        const msg =
          updateResponse?.data?.message ||
          lastError?.response?.data?.message ||
          lastError?.message ||
          'Failed to update order';
        toast.error(msg);
        if (lastError) {
          throw lastError;
        }
      }
      const response = yield getRequest('order');
      if (response?.status == 200) {
        yield put(successOrderListDB(response?.data));
      }
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message || error?.message || 'Failed to update order');
      yield put(failedOrderListDB(error));
    }
  }
  
